export const GET_MATTERS_REQUEST = "GET_MATTERS_REQUEST";
export const GET_MATTERS_SUCCESS = "GET_MATTERS_SUCCESS";
export const GET_MATTERS_FAIL = "GET_MATTERS_FAIL";
export const GET_MATTERS_RESET = "GET_MATTERS_RESET";